import { PrimaryUser, UserDetails, UserFields } from "features/types";
import { get, post } from "./http";

const BASE = "users";

class UserService {
  userExists(email: string) {
    return get({
      url: `${BASE}/exists`,
      params: {
        email,
      },
    }).then((res) => res.value) as Promise<boolean>;
  }

  register(user: PrimaryUser, userFields: UserFields) {
    return post({
      url: `${BASE}/register`,
      params: {
        ...user,
        userFields,
      },
    }) as Promise<UserDetails>;
  }
}

export default new UserService();
